import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { TaskCaseService } from 'src/app/modules/case/services/taskCase.service';
import { CasoTareaService } from 'src/app/services/casos_tareas.service';
import { NotificacionService } from 'src/app/services/notificaciones.service';
import { RolesPermisosService } from 'src/app/services/roles_permisos.service';
import { TareaCasoService } from 'src/app/services/tareacaso.service';

@Component({
  selector: 'app-elaborar-informe-pesquisa',
  templateUrl: './elaborar-informe-pesquisa.component.html',
  styleUrls: ['./elaborar-informe-pesquisa.component.scss'],
})
export class ElaborarInformePesquisaComponent implements OnInit {
  constructor(private fb: FormBuilder) {}

  // form: FormGroup;
  // @Input() data: { task: any };

  ngOnInit() {
    // const { task } = this.data;
    // const values = task.data ? task.data : null;
    // this.form = this.fb.group({
    //   // is: [values ? values.is : ''],
    //   descripcion: [values ? values.descripcion : ''],
    //   nombre: [values ? values.nombre : ''],
    //   cargo: [values ? values.cargo : ''],
    //   NM: [values ? values.NM : ''],
    // });
    // this.changeIsInvolved(values ? values.is : '');
  }
  // changeIsInvolved(value) {
  //   if (value == 'si') {
  //     this.form.controls.descripcion.setValidators([Validators.required]);
  //     this.form.controls.nombre.setValidators([Validators.required]);
  //     this.form.controls.cargo.setValidators([Validators.required]);
  //     this.form.controls.NM.setValidators([Validators.required]);
  //   } else {
  //     this.form.controls.descripcion.setValidators([]);
  //     this.form.controls.nombre.setValidators([]);
  //     this.form.controls.cargo.setValidators([]);
  //     this.form.controls.NM.setValidators([]);
  //   }
  // }
}
